export default __webpack_public_path__ + "static/media/figuremap14.36d339d7.png";